import {IConfigurationEvaluationContext} from '../configuration-evaluation-context/configuration-evaluation-context.interface';
import {IComparisonOperator} from '../statements/comparison-operators/comparison-operator.interface/comparison-operator.interface';
import {ISegmentationRule} from '../statements/segmentation-rule/segmentation-rule.interface';
import {ILogicalOperator} from '../statements/logical-operators/logical-operator.interface/logical-operator.interface';
import {IStatementEvaluator} from '../statements/statement-evaluator/statement-evaluator.interface';
import {IValueEvaluator} from '../value-evaluators/value-evaluator.interface/value-evaluator.interface';
import {IPropertyEvaluator} from '../property-evaluator/property-evaluator.interface';


export class PropertyLevelContext implements IConfigurationEvaluationContext {
  constructor(private _originalContext: IConfigurationEvaluationContext, private _currentPropertyName) {

  }

  createComparisonOperator(operatorName: string): IComparisonOperator {
    return this._originalContext.createComparisonOperator(operatorName);
  }

  createLogicalOperator(logicalOperatorName: string, rules: ISegmentationRule[]): ILogicalOperator {
    return this._originalContext.createLogicalOperator(logicalOperatorName, rules);
  }

  createSegmentationRule(ruleDefinition: any): ISegmentationRule {
    return this._originalContext.createSegmentationRule(ruleDefinition);
  }

  createStatementEvaluator(statementDefinition: any): IStatementEvaluator {
    return this._originalContext.createStatementEvaluator(statementDefinition);
  }

  getSegmentValue(name: string): any {
    return this._originalContext.getSegmentValue(name);
  }

  parsePropertyValue(value: any): IValueEvaluator {
    return this._originalContext.parsePropertyValue(value);
  }


  getCurrentPropertyPath(): string {
    return this._originalContext.getCurrentPropertyPath() + '/' + this._currentPropertyName;
  }

  createPropertyContext(propertyName: string): IConfigurationEvaluationContext {
    return new PropertyLevelContext(this, propertyName);
  }

  applyValueTransformation(propertyPath: string, value: any): any {
    return this._originalContext.applyValueTransformation(propertyPath, value);
  }

  createPropertyEvaluator(propertyName: string, propertyOwner: object): IPropertyEvaluator {
    return this._originalContext.createPropertyEvaluator(propertyName, propertyOwner);
  }

  getLauncherGames(): number[] {
    return this._originalContext.getLauncherGames();
  }
}
